import React from "react";
import { Link } from "react-router-dom";
import { LoginFormProp } from "../../../../../Types/OthersType";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

const CommonLogo: React.FC<LoginFormProp> = ({ logoClass }) => {
  return (
    <Link className={`logo ${logoClass}`} to={`${process.env.PUBLIC_URL}/dashboard/default`}>
      <Image className="img-fluid for-light" src={dynamicImage(`logo/logo.png`)} alt="looginpage" body={true} />
      <Image className="img-fluid for-dark m-auto" src={dynamicImage(`logo/logo_dark.png`)} alt="looginpage" body={true} />
    </Link>
  );
};
export default CommonLogo;
